<template>
    <div class="viewport">
        <div ref="cube" class="cube">
            <div class="side relative">
                <div class="cube-inner flex justify-center items-center">
                    <slot class="cube-content" name="side-0"></slot>
                </div>
                <div class="overlay absolute top-0 bottom-0 right-0 w-full h-full" />
            </div>
            <div class="side">
                <div class="cube-inner flex justify-center items-center">
                    <slot class="cube-content" name="side-1"></slot>
                </div>
                <div class="overlay absolute top-0 bottom-0 right-0 w-full h-full" />
            </div>
            <div class="side">
                <div class="cube-inner flex justify-center items-center">
                    <slot class="cube-content" name="side-2"></slot>
                </div>
                <div class="overlay absolute top-0 bottom-0 right-0 w-full h-full" />
            </div>
            <div class="side">
                <div class="cube-inner flex justify-center items-center">
                    <slot class="cube-content" name="side-3"></slot>
                </div>
                <div class="overlay absolute top-0 bottom-0 right-0 w-full h-full" />
            </div>
            <div class="side">
                <div class="cube-inner flex justify-center items-center">
                    <slot class="cube-content" name="side-4"></slot>
                </div>
                <div class="overlay absolute top-0 bottom-0 right-0 w-full h-full" />
            </div>
            <div class="side">
                <div class="cube-inner flex justify-center items-center">
                    <slot class="cube-content" name="side-5"></slot>
                </div>
                <div class="overlay absolute top-0 bottom-0 right-0 w-full h-full" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['activeSide', 'color', 'gradientColor'],

    mounted() {
        // initially set each elements background color and show them
        _.forEach(this.$refs.cube.childNodes, (element) => {
            element.style.background = this.color;
            element.classList.add('show');
        });
    },

    methods: {
        // hide all element except one item
        hideExcept(except) {
            _.forEach(this.$refs.cube.childNodes, (element, index) => {
                index != except
                    ? [element.childNodes[0].classList.add('hide'), element.childNodes[0].classList.remove('show')]
                    : [element.childNodes[0].classList.add('show'), element.childNodes[0].classList.remove('hide')];
            });
        },

        // set the gradient on the given element
        setGradient(element, from, to, direction) {
            let gradient = 'linear-gradient(' + direction + ', ' + from + ', ' + to + ')';

            element.style.background = gradient;
        }
    },

    watch: {
        // calculate the rotation and color depending on the given active side
        activeSide: function () {
            let that = this;

            let from = this.$hexToRgbA(this.color, 1);
            let to = this.$hexToRgbA(this.gradientColor, 1);

            _.forEach(this.$refs.cube.childNodes, (element) => {
                element.classList.remove('show');
                element.style.background = this.color;
                element.querySelector('.overlay').style.background = '';
            });

            // hide all sides except the active one
            this.hideExcept(this.activeSide);

            if (this.activeSide === 0) {
                this.$refs.cube.style.transform = 'rotateX(-450deg) rotateY(-180deg)';
            }

            if (this.activeSide === 1) {
                this.$refs.cube.style.transform = 'rotateX(-520deg) rotateY(-160deg)';
                this.setGradient(this.$refs.cube.childNodes[0].querySelector('.overlay'), from, to, 'to right');
                this.setGradient(this.$refs.cube.childNodes[4].querySelector('.overlay'), from, to, 'to right');
            }

            if (this.activeSide === 2) {
                this.$refs.cube.style.transform = 'rotateX(-920deg) rotateY(-250deg)';
                this.setGradient(this.$refs.cube.childNodes[1].querySelector('.overlay'), from, to, 'to right');
                this.setGradient(this.$refs.cube.childNodes[5].querySelector('.overlay'), from, to, 'to right');
            }

            if (this.activeSide === 3) {
                this.$refs.cube.style.transform = 'rotateX(-880deg) rotateY(-380deg)';
                this.setGradient(this.$refs.cube.childNodes[0].querySelector('.overlay'), from, to, 'to right');
                this.setGradient(this.$refs.cube.childNodes[4].querySelector('.overlay'), from, to, 'to right');
            }

            if (this.activeSide === 4) {
                this.$refs.cube.style.transform = 'rotateX(-920deg) rotateY(-470deg)';
                this.setGradient(this.$refs.cube.childNodes[1].querySelector('.overlay'), from, to, 'to right');
                this.setGradient(this.$refs.cube.childNodes[5].querySelector('.overlay'), from, to, 'to right');
            }

            if (this.activeSide === 5) {
                this.$refs.cube.style.transform = 'rotateX(-630deg) rotateY(-360deg)';
            }

            setTimeout(() => {
                _.forEach(that.$refs.cube.childNodes, (element) => {
                    element.classList.add('show');
                });
            }, 100);
        }
    }

    // NOTICE: Those are the Values for the perspectives
    // Perspectives
    // 2 (1)
    // rotateX(-180deg) rotateY(-180deg)
    // rotateX(-160deg) rotateY(-160deg)

    // 3 (2)
    // rotateX(-900deg) rotateY(-270deg)
    // rotateX(-920deg) rotateY(-250deg)

    // 4 (3)
    // rotateX(-900deg) rotateY(-360deg)
    // rotateX(-880deg) rotateY(-380deg)

    // 5 (4)
    // rotateX(-900deg) rotateY(-450deg)
    // rotateX(-920deg) rotateY(-470deg)

    // 6 (5)
    // rotateX(-630deg) rotateY(-360deg)
};
</script>

<style scoped>
#wrapper {
    padding-top: 10%;
}

.viewport {
    -webkit-perspective: 800px;
    -moz-perspective: 800px;
    -ms-perspective: 800px;
    -o-perspective: 800px;
    perspective: 800px;
    -webkit-perspective-origin: 50% 200px;
    -moz-perspective-origin: 50% 200px;
    -ms-perspective-origin: 50% 200px;
    -o-perspective-origin: 50% 200px;
    perspective-origin: 50% 200px;
    -webkit-transform: scale(0.8, 0.8);
    -moz-transform: scale(0.8, 0.8);
    -ms-transform: scale(0.8, 0.8);
    -o-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
}

.cube {
    position: relative;
    margin: 0 auto;
    height: 200px;
    width: 200px;
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;
    -ms-transform-style: preserve-3d;
    -o-transform-style: preserve-3d;
    transform-style: preserve-3d;
    -webkit-transform: rotateX(-450deg) rotateY(-180deg);
    -moz-transform: rotateX(-450deg) rotateY(-180deg);
    -ms-transform: rotateX(-450deg) rotateY(-180deg);
    -o-transform: rotateX(-450deg) rotateY(-180deg);
    transform: rotateX(-450deg) rotateY(-180deg);
}

.cube > div {
    overflow: hidden;
    position: absolute;
    height: 200px;
    width: 200px;
    -webkit-touch-callout: none;
    -moz-touch-callout: none;
    -ms-touch-callout: none;
    -o-touch-callout: none;
    touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}

.cube > div > div.cube-inner {
    width: 200px;
    height: 200px;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
    text-align: center;
    color: #ffffff;
    -webkit-transition: color 600ms;
    -moz-transition: color 600ms;
    -ms-transition: color 600ms;
    -o-transition: color 600ms;
    transition: color 600ms;
}

.cube > div > div.cube-inner.active {
    color: #ffffff;
}

.cube > div:hover {
    cursor: pointer;
}

.cube > div:active {
    cursor: pointer;
}

.cube > div:first-child {
    -webkit-transform: rotateX(90deg) translateZ(100px);
    -moz-transform: rotateX(90deg) translateZ(100px);
    -ms-transform: rotateX(90deg) translateZ(100px);
    -o-transform: rotateX(90deg) translateZ(100px);
    transform: rotateX(90deg) translateZ(100px);
    outline: 1px solid transparent;
}

.cube > div:nth-child(2) {
    -webkit-transform: translateZ(100px);
    -moz-transform: translateZ(100px);
    -ms-transform: translateZ(100px);
    -o-transform: translateZ(100px);
    transform: translateZ(100px);
    outline: 1px solid transparent;
}

.cube > div:nth-child(3) {
    -webkit-transform: rotateY(90deg) translateZ(100px);
    -moz-transform: rotateY(90deg) translateZ(100px);
    -ms-transform: rotateY(90deg) translateZ(100px);
    -o-transform: rotateY(90deg) translateZ(100px);
    transform: rotateY(90deg) translateZ(100px);
    outline: 1px solid transparent;
}

.cube > div:nth-child(4) {
    -webkit-transform: rotateY(180deg) translateZ(100px);
    -moz-transform: rotateY(180deg) translateZ(100px);
    -ms-transform: rotateY(180deg) translateZ(100px);
    -o-transform: rotateY(180deg) translateZ(100px);
    transform: rotateY(180deg) translateZ(100px);
    outline: 1px solid transparent;
}

.cube > div:nth-child(5) {
    -webkit-transform: rotateY(-90deg) translateZ(100px);
    -moz-transform: rotateY(-90deg) translateZ(100px);
    -ms-transform: rotateY(-90deg) translateZ(100px);
    -o-transform: rotateY(-90deg) translateZ(100px);
    transform: rotateY(-90deg) translateZ(100px);
    outline: 1px solid transparent;
}

.cube > div:nth-child(6) {
    -webkit-transform: rotateX(-90deg) rotate(180deg) translateZ(100px);
    -moz-transform: rotateX(-90deg) rotate(180deg) translateZ(100px);
    -ms-transform: rotateX(-90deg) rotate(180deg) translateZ(100px);
    -o-transform: rotateX(-90deg) rotate(180deg) translateZ(100px);
    transform: rotateX(-90deg) rotate(180deg) translateZ(100px);
    outline: 1px solid transparent;
}

@media (max-width: 640px) {
    .viewport {
        -webkit-transform: scale(0.6, 0.6);
        -moz-transform: scale(0.6, 0.6);
        -ms-transform: scale(0.6, 0.6);
        -o-transform: scale(0.6, 0.6);
        transform: scale(0.6, 0.6);
    }
}

.show {
    opacity: 1;
    transition:
        opacity 500ms,
        border-radius 1500ms;
    border-radius: 15px;
}

.hide {
    opacity: 0;
    border-radius: 0px;
}
</style>
